import { IJobCandidateInteraction } from 'wisestep-api';

export const JobsCrmDefaultRequest: IJobCandidateInteraction = {
  timeTakenInMillis: 0,
  page: 0,
  size: 20,
  sort: ['_score,desc'],
  minSalary: 0,
  maxSalary: 0,
  radiusInMiles: 100,
  searchScope: 'EVERYTHING',
  candidateSearchTypeList: ['mapped', 'submitted', 'uploaded', 'applied'],
  jobSearchFields: ['currentJobTitle', 'mappedJobTitle', 'previousJobTitles'],
  datesUnionBy: 'UPDATED_BETWEEN',
  searchAcross: ['ACROSS_WORKSPACE'],
  minMatchScore: 60,
};
